import API from './api';

export default {
    getSubscriptionStatus: (organizationId) => API({
        url: `organizations/${organizationId}/subscription/status`,
        method: 'GET',
    }),

    getAvailableProducts: () => API({
        url: 'subscriptions/products',
        method: 'GET',
    }),

    createCheckoutSession: (organizationId, priceId) => API({
        url: 'subscriptions/create-checkout-session',
        method: 'POST',
        json: { organizationId, priceId }
    }),

    createPortalSession: (organizationId) => API({
        url: 'subscriptions/create-portal-session',
        method: 'POST',
        json: { organizationId }
    }),
};
